import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Card } from 'primereact/card';
import emailjs from '@emailjs/browser';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    contacto: '',
    mensaje: ''
  });

  const [error, setError] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e, field) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      return setError('Por favor ingresa tu nombre.');
    }
    if (!formData.contacto.trim()) {
      return setError('Por favor ingresa tu número o correo.');
    }
    if (!formData.mensaje.trim()) {
      return setError('Por favor escribe un mensaje.');
    }

    setError('');

    // 📤 Enviar con EmailJS
    emailjs.send(
      'service_gbwfgi8',       // Service ID
      'template_4eipcj1',      // Template ID
      {
        from_name: formData.nombre,
        from_email: formData.contacto,
        message: formData.mensaje+', Nombre: '+formData.nombre+', Contacto: '+formData.contacto,
      },
      'ofz7ycdI5cOUWjddW'        // Public Key
    ).then(() => {
      setEnviado(true);
      setFormData({ nombre: '', contacto: '', mensaje: '' });
      setTimeout(() => setEnviado(false), 4000);
    }).catch((err) => {
      console.error('❌ Error enviando email:', err);
      setError('Hubo un problema enviando el mensaje.');
    });
  };

  return (
    <Card title="Formulario de Contacto" className="w-full md:w-30rem mx-auto mt-6">
      <form onSubmit={handleSubmit} className="p-fluid">

        <div className="field mb-3">
          <label htmlFor="nombre" className="block mb-2">Nombre</label>
          <InputText
            id="nombre"
            value={formData.nombre}
            onChange={(e) => handleChange(e, 'nombre')}
            placeholder="Tu nombre"
          />
        </div>

        <div className="field mb-3">
          <label htmlFor="contacto" className="block mb-2">Correo o Teléfono</label>
          <InputText
            id="email"
            value={formData.contacto}
            onChange={(e) => handleChange(e, 'contacto')}
            placeholder="correo@ejemplo.com o 555-123-4567"
          />
        </div>

        <div className="field mb-3">
          <label htmlFor="mensaje" className="block mb-2">Mensaje</label>
          <InputTextarea
            id="mensaje"
            value={formData.mensaje}
            onChange={(e) => handleChange(e, 'mensaje')}
            placeholder="Escribe tu mensaje aquí..."
            rows={5}
            autoResize
          />
        </div>

        {error && <Message severity="error" text={error} className="mb-3" />}
        {enviado && <Message severity="success" text="Mensaje enviado con éxito." className="mb-3" />}

        <Button type="submit" label="Enviar" icon="pi pi-send" />
      </form>
    </Card>
  );
};

export default Contacto;